import 'reflect-metadata'
import { Transform } from 'class-transformer'
import {
  IsBoolean,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  MaxLength,
  Min,
} from 'class-validator'
import { SpecificationType } from '../enums/specification-type.enum'

const trim = ({ value }: { value: unknown }) => (typeof value === 'string' ? value.trim() : value)

export class V2Specification {
  id!: number
  name!: string
  specificationType!: SpecificationType
  regionId!: number
  regionName!: string
  countryId!: number
  countryName!: string
  cropTypeId?: number
  cropTypeName?: string
  isActive!: boolean
  /** false for locked reference specifications: no edit, no delete */
  isEditable!: boolean
}

export class SaveV2Specification {
  @Transform(trim)
  @IsString()
  @IsNotEmpty()
  @MaxLength(90)
  name!: string

  @IsEnum(SpecificationType)
  specificationType!: SpecificationType

  @IsInt()
  @IsPositive()
  regionId!: number

  @IsInt()
  @IsPositive()
  countryId!: number

  @IsInt()
  @IsPositive()
  cropTypeId!: number

  @IsBoolean()
  isActive!: boolean
}

export class V2SpecificationProductIngredient {
  name!: string
  concentration!: number
  unit!: string
}

/** A product of a specification, with the limits that apply to it. */
export class V2SpecificationProduct {
  id!: number
  productId!: number
  productCountryId!: number
  productName!: string
  productActive!: boolean
  pesticideType?: string
  rateUnitId?: number
  rateUnit?: string
  dosage!: number
  cumulative?: number
  passageNumber?: number
  phi?: number
  note?: string
  /** Last use date, ISO yyyy-mm-dd */
  lastUse?: string
  ingredients!: V2SpecificationProductIngredient[]
}

export class SaveV2SpecificationProduct {
  @IsInt()
  @IsPositive()
  productCountryId!: number

  @IsNumber({ allowInfinity: false, allowNaN: false })
  @Min(0)
  dosage!: number

  @IsInt()
  @IsPositive()
  rateUnitId!: number

  @IsInt()
  @Min(1)
  passageNumber!: number

  @IsInt()
  @Min(0)
  phi!: number

  @IsOptional()
  @Transform(trim)
  @IsString()
  @MaxLength(4000)
  note?: string
}

/** A product that can still be added to a specification: active, registered in its country. */
export class V2SpecificationProductOption {
  productCountryId!: number
  productName!: string
}

export class V2RateUnit {
  id!: number
  code!: string
}
